import React, { FunctionComponent } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import DesktopWindowsIcon from "@material-ui/icons/DesktopWindows";
import DesktopAccessDisabledIcon from "@material-ui/icons/DesktopAccessDisabled";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import { DialogTitle } from "@material-ui/core";
import { eodItemStyles } from "../../eodItemStyles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: "center",
      color: theme.palette.text.secondary
    },
    desktopWindowsIcon: {
      fontSize: "2em"
    }
  })
);
type TerminalScreenProps = {
  terminalDetails: Array<object>;
  openTerminalDialog: boolean;
  markDeffectiveTerminals: (offlineTerminals: Array<string>) => Promise<void>;
  retryEodProcess: (type: string) => void;
  eodReportDetails: any;
  reportFlag: boolean
};
export const TerminalScreen: FunctionComponent<TerminalScreenProps> = ({
  terminalDetails,
  openTerminalDialog,
  markDeffectiveTerminals,
  retryEodProcess,
  eodReportDetails,
  reportFlag
}) => {
  const classes = useStyles();
  const styles = eodItemStyles();

  let offlineTerminalsFiltered =
    terminalDetails &&
    terminalDetails.filter((terminal: any) => terminal.is_online === false);
  // let offlineTerminalNames =
  //   offlineTerminalsFiltered &&
  //   offlineTerminalsFiltered.map(
  //     (offlineTerminal: any) => offlineTerminal.name
  //   );
  let offlineTerminalIds =
    offlineTerminalsFiltered &&
    offlineTerminalsFiltered.map((offlineTerminal: any) => offlineTerminal.id);

  return (
    <div className={classes.root}>
      {reportFlag && terminalDetails !== undefined ? (
        <Grid container spacing={3} justify="center" alignItems="center">
          <Grid item xs={12}>
            <Paper className={classes.paper}>
              <Typography variant="h5" color="textPrimary">
                Terminals
            </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12}>
            <Paper className={classes.paper}>
              <Grid
                container
                spacing={1}
                justify="flex-start"
                alignItems="center"
              >
                {terminalDetails &&
                  terminalDetails.map((terminal: any) => (
                    <Grid item xs={2} style={{ textAlign: "center" }}>
                      {terminal.is_online ? (
                        <DesktopWindowsIcon
                          className={classes.desktopWindowsIcon}
                          style={{ color: "#64dd17" }}
                        />
                      ) : (
                          <DesktopAccessDisabledIcon
                            className={classes.desktopWindowsIcon}
                            style={{ color: "#b71c1c" }}
                          />
                        )}

                      <Typography variant="subtitle1">{terminal.name}</Typography>
                    </Grid>
                  ))}
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      ) : ""}

      <Dialog
        open={openTerminalDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="customized-dialog-title" style={{ backgroundColor: "#3d5a79" }}>
          <Typography className={styles.dialogTitleStyle}>
            Confirmation-Dialog
          </Typography>
        </DialogTitle>
        <DialogContent dividers>
          <DialogContentText id="alert-dialog-description">
            <Typography className={styles.errorMessageStyle}>
              {eodReportDetails.message}  <br />
            Do you want to mark those terminal as deffective or retry
            the process?
            </Typography>

          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { retryEodProcess("retry") }}>Retry</Button>
          <Button onClick={() => markDeffectiveTerminals(offlineTerminalIds)}>
            Marks as deffective
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
